<script lang="ts">
    import {Component, toNative, Vue} from 'vue-facing-decorator'
    import FlightsPage from '@/pages/flights/FlightsPage.vue'

    @Component({
        mixins: [FlightsPage],
        async setup() {
            const route = useRoute()
            await useAsyncData(`flight-${route.name.toString()}`, async () => {
                flightsRuntimeStore.SET_SEARCH_TYPE(route.name === 'flights' ? 'price' : 'schedule')
                return true
            })
        },
    })
    export class FlightsAvailabilityPage extends Vue {
        async load() {
            await this.$store.restored
            await this.loadRuntimeData()
            this.loaded = true
            await this.search()
            this.productRuntimeStore.filter({offers: this.searchResponse.offers, filters: this.filterValues})
        }

        async search() {
            await this.productRuntimeStore.checkAvailability(this.productStore.availabilityRequest)
        }

        changeFilter(data) {
            this.productStore.SET_AVAILABLE_OFFER_FILTER(data)
            this.productRuntimeStore.filter({offers: this.searchResponse.offers, filters: this.filterValues})
        }

        resetFilters() {
            this.productStore.RESET_AVAILABLE_OFFER_FILTERS()
            this.productRuntimeStore.filter({offers: this.searchResponse.offers, filters: this.filterValues})
        }

        get sortKey() {
            return this.productStore.sortFnName
        }

        set sortKey(sortKey) {
            this.productStore.SET_SORT(sortKey)
            this.productRuntimeStore.filter({offers: this.searchResponse.offers, filters: this.filterValues})
        }

        get searchRequest() {
            return this.productStore.scheduleSearchRequest
        }

        get searchResponse() {
            return this.productStore.availabilityResponse
        }

        get filterValues() {
            return this.productStore.availableOfferFilters
        }

        get searchActive() {
            return this.productRuntimeStore.checkAvailabilityActive
        }

        get currency() {
            return this.productStore.scheduleSearchRequest.convertToCurrency !== 'ORIGINAL'
                ? this.productStore.searchRequest.convertToCurrency
                : this.filteredOffers[0]?.price.currency
        }
    }

    export default {...toNative(FlightsAvailabilityPage), ssrRender: FlightsPage.ssrRender}
</script>
